import React from 'react';
import { Link, useParams } from 'react-router-dom';
import './UsedItems.css';
import { FaArrowRight } from 'react-icons/fa';
import item1 from './usedItems/Mana Acoustics reference rack.jpg';
import item2 from './usedItems/Kudos Titan 606 Speakers.jpg';
import item3 from './usedItems/Karan Acoustics Master Collection Stereo A Power Amplifier.jpg';
import item4 from './usedItems/Karan Acoustics Phono 2.jpg';
import item5 from './usedItems/Kudos Audio C20 Speakers.jpg';
import item6 from './usedItems/DSA Amp 1.jpg';
import item7 from './usedItems/DSA Pre 1.jpg';
import item8 from './usedItems/Furutech Demag.jpg';
import './responsive.css';

function Tab3Content()  {
  return (
    <div className="useditems-container">
                <div className="product-container">
                <img src={item1} alt="Mana Acoustics reference rack" className="image"/>

                <div className="caption">
                  <div>Mana Acoustics Reference Rack</div>
                  <div>
                    <Link to="/usedItems/Mana Acoustics Reference Rack" className="arrow-link">
                    <span className="link-caption">View details</span>
                      <FaArrowRight />
                    </Link>
                  </div>
                </div>
              </div>

             <div className="product-container">
              <img src={item2} alt="item2" className="image"/>

               <div className="caption">
               <div>Kudos Titan 606 Speakers</div>
               <div>
                <Link to="/usedItems/Kudos Titan 606 Speakers" className="arrow-link">
                <span className="link-caption">View details</span>
              <FaArrowRight />
            </Link>
              </div>
                </div>
                </div>

             <div className="product-container">
              <img src={item3} alt="item3" className="image"/>

               <div className="caption">
               <div>Karan Acoustics Master Collection Stereo A Power Amplifier</div>
               <div>
                <Link to="/usedItems/Karan Acoustics Master Collection Stereo A Power Amplifier" className="arrow-link">
                <span className="link-caption">View details</span>
              <FaArrowRight />
            </Link>
              </div>
                </div>
                </div>

               <div className="product-container">
              <img src={item4} alt="item4" className="image"/>

               <div className="caption">
               <div>Karan Acoustics Phono 2</div>
               <div>
                <Link to="/usedItems/Karan Acoustics Phono 2" className="arrow-link">
                <span className="link-caption">View details</span>
              <FaArrowRight />
            </Link>
              </div>
                </div>
                </div>

               <div className="product-container">
              <img src={item5} alt="item5" className="image"/>

               <div className="caption">
               <div>Kudos Audio C20 Speakers</div>
               <div>
                <Link to="/usedItems/Kudos Audio C20 Speakers" className="arrow-link">
                <span className="link-caption">View details</span>
              <FaArrowRight />
            </Link>
              </div>
                </div>
                </div>

               <div className="product-container">
              <img src={item6} alt="item6" className="image"/>

               <div className="caption">
               <div>DSA Amp 1</div>
               <div>
                <Link to="/usedItems/DSA Amp 1" className="arrow-link">
                <span className="link-caption">View details</span>
              <FaArrowRight />
            </Link>
              </div>
                </div>
                </div>

               <div className="product-container">
              <img src={item7} alt="item7" className="image"/>

               <div className="caption">
                <div>DSA Pre 1</div>
                <div>
                <Link to="/usedItems/DSA Pre 1" className="arrow-link">
                <span className="link-caption">View details</span>
            <FaArrowRight />
            </Link>
              </div>
              </div>
                </div>

                <div className="product-container">
              <img src={item8} alt="item8" className="image"/>

               <div className="caption">
               <div>Furutech Demag</div>
               <div>
               <Link to="/usedItems/Furutech Demag" className="arrow-link">
               <span className="link-caption">View details</span>
            <FaArrowRight />
            </Link>
              </div>
                </div>
                </div>
                {/* </div> */}
    </div>
          );
  } 


export default Tab3Content;
